import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import Flatpickr from "react-flatpickr";
import moment from "moment";

// Image
import overview01 from "assets/images/product/overview-01.png";
import overview02 from "assets/images/product/overview-02.png";

import productImg01 from "assets/images/product/img-01.png";
import productImg09 from "assets/images/product/img-09.png";
import productImg12 from "assets/images/product/img-12.png";
import productImg13 from "assets/images/product/img-13.png";
import userDummy from "assets/images/users/user-dummy-img.jpg";

// Icon
import {
  ShoppingCart,
  Repeat,
  HelpCircle,
  Share2,
  Store,
  Star,
  MapPin,
  MoreHorizontal,
  FileEdit,
  Trash2,
  Truck,
  Container,
  ThumbsUp,
  ThumbsDown,
  Tag,
} from "lucide-react";
import { Dropdown } from "Common/Components/Dropdown";
import { Link, useParams } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";

// react-redux
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  getReview as onGetReview,
  addReview as onAddReview,
  updateReview as onUpdateReview,
  deleteReview as onDeleteReview,
  getJewelleryById as onGetJewelleryById,
} from "slices/thunk";
import { formateDate } from "utils/date";
import ImageSlider from "./ImageSlider";
import { setIsEditing } from "slices/jewellery/reducer";
import {
  PriceResponse,
  useJewelleryContext,
} from "context/JwelleryPriceContext";

const JewelleryOverview = () => {
  const dispatch = useDispatch<any>();
  const { id } = useParams();

  const selectDataList = createSelector(
    (state: any) => state.Jewellery,
    (state) => ({
      jewellery: state.jewellery,
    })
  );

  const { jewellery } = useSelector(selectDataList);

  const { handleJewelleryPrice } = useJewelleryContext();

  const [images, setImages] = useState<string[]>([]);
  const [eventData, setEventData] = useState<any>();
  const [metal, setMetal] = useState<"yellowgold" | "rosegold" | "whitegold">("yellowgold");
  const [karat, setKarat] = useState<"14k" | "18k">("18k");

  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell);
    }
  };

  const handleDelete = () => {
    if (eventData) {
      dispatch(onDeleteReview(eventData.id));
      setDeleteModal(false);
    }
  };
  //

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      img: (eventData && eventData.img) || "",
      customerName: (eventData && eventData.customerName) || "",
      date: (eventData && eventData.date) || "",
      rating: (eventData && eventData.rating) || "",
      review: (eventData && eventData.review) || "",
      like: (eventData && eventData.like) || "",
      dislike: (eventData && eventData.dislike) || "",
    },
    validationSchema: Yup.object({
      date: Yup.string().required("Please Enter Date"),
      rating: Yup.string().required("Please Enter Rating"),
      review: Yup.string().required("Please Enter review"),
    }),

    onSubmit: (values) => {
      if (isEdit) {
        const updateData = {
          id: eventData ? eventData.id : 0,
          ...values,
        };
        // update user
        dispatch(onUpdateReview(updateData));
      } else {
        const newData = {
          ...values,
          id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(),
          img: userDummy,
          customerName: "Paula Keenan",
          like: "0",
          dislike: "0",
        };
        // save new user
        dispatch(onAddReview(newData));
      }
      toggle();
    },
  });

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  useEffect(() => {
    if (id) {
      dispatch(onGetJewelleryById(id));
    }
  }, [id]);

  const StareRating = ({ item }: any) => {
    switch (item) {
      case "5":
        return (
          <div className="flex items-center gap-2 mt-4 mb-2 text-yellow-500">
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
          </div>
        );
      case "4":
        return (
          <div className="flex items-center gap-2 mt-4 mb-2 text-yellow-500">
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-line"></i>
          </div>
        );
      case "3":
        return (
          <div className="flex items-center gap-2 mt-4 mb-2 text-yellow-500">
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
          </div>
        );
      case "2":
        return (
          <div className="flex items-center gap-2 mt-4 mb-2 text-yellow-500">
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
          </div>
        );
      case "1":
        return (
          <div className="flex items-center gap-2 mt-4 mb-2 text-yellow-500">
            <i className="ri-star-fill"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
          </div>
        );
      default:
        return (
          <div className="flex items-center gap-2 mt-4 mb-2 text-yellow-500">
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
            <i className="ri-star-line"></i>
          </div>
        );
    }
  };

  const handleSelectionChange = (
    selectedMetal: "yellowgold" | "rosegold" | "whitegold",
    selectedKarat: "14k" | "18k"
  ) => {
    setMetal(selectedMetal);
    setKarat(selectedKarat);
  };

  // Calculate the combined price
  const totalJewelleryPrice: any = handleJewelleryPrice(
    jewellery,
    metal,
    karat,
    1,
    "combined"
  );

  // Calculate the separate prices (metal and diamond)
  const separatePrices: any = handleJewelleryPrice(
    jewellery,
    metal,
    karat,
    1,
    "separate"
  );

  useEffect(() => {
    if (jewellery) {
      const data = jewellery.media.find((media: any) => media.type === metal);
      data?.images.length && setImages(data.images);
    }
  }, [jewellery, metal, karat]);

  const mainDiamond = {
    id: "main-stone",
    carat: 1,
    color: "DEF",
    clarity: "VVS",
    shape: jewellery?.shape, // Using product shape
    pieces: 1,
  };

  const diamondsWithMain: any = [mainDiamond, ...(jewellery?.diamonds || [])];

  // const mainDiamond = {
  //   id: "main-stone",
  //   carat: 1,
  //   color: "DEF",
  //   clarity: "VVS",
  //   shape: jewellery?.shape, // Using product shape
  //   pieces: 1,
  // };

  // const diamondsWithMain: any = [mainDiamond, ...(jewellery?.diamonds || [])];

  // useEffect(() => {
  //   if (diamondsWithMain) {
  //     (async () => {
  //       const response: any = await getDiamondPrices(diamondsWithMain);
  //       setDiamondPrices(response);
  //     })();
  //   }
  // }, []);

  return (
    <React.Fragment>
      <BreadCrumb title="Overview" pageTitle="Products" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />

      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-4">
          <div className="sticky top-[calc(theme('spacing.header')_*_1.3)] mb-5">
            <div className="card">
              <div className="card-body">
                <ImageSlider images={images} />
                <div className="flex gap-2 mt-4 shrink-0">
                  <Link
                    to="/apps-ecommerce-cart"
                    type="button"
                    className="w-full bg-white border-dashed text-custom-500 btn border-custom-500 hover:text-custom-500 hover:bg-custom-50 hover:border-custom-600 focus:text-custom-600 focus:bg-custom-50 focus:border-custom-600 active:text-custom-600 active:bg-custom-50 active:border-custom-600 dark:bg-zink-700 dark:ring-custom-400/20 dark:hover:bg-custom-800/20 dark:focus:bg-custom-800/20 dark:active:bg-custom-800/20"
                  >
                    <ShoppingCart className="inline-block size-3 align-middle ltr:mr-1 rtl:ml-1" />
                    <span className="align-middle">Add to Cart</span>
                  </Link>
                  <button
                    type="button"
                    className="w-full text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-red-400/20"
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="xl:col-span-8">
          <div className="card">
            <div className="card-body">
              <Dropdown className="relative ltr:float-right rtl:float-left dropdown">
                <Dropdown.Trigger
                  className="flex items-center justify-center size-[30px] dropdown-toggle p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20"
                  id="categoryNotes1"
                  data-bs-toggle="dropdown"
                >
                  <MoreHorizontal className="size-3" />
                </Dropdown.Trigger>
                <Dropdown.Content
                  className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md dropdown-menu min-w-[10rem] dark:bg-zink-600"
                  aria-labelledby="categoryNotes1"
                >
                  <li>
                    <Link
                      className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                      to={`/update-jewellery/${jewellery?._id}`}
                      onClick={() => {
                        dispatch(setIsEditing(true));
                      }}
                    >
                      <FileEdit className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                      <span className="align-middle">Edit</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                      to="#!"
                      onClick={deleteToggle}
                    >
                      <Trash2 className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                      <span className="align-middle">Delete</span>
                    </Link>
                  </li>
                </Dropdown.Content>
              </Dropdown>
              <span className="px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-sky-100 border-sky-100 text-sky-500 dark:bg-sky-400/20 dark:border-transparent">
                {" "}
                New Arrivals
              </span>
              <h5 className="mt-3 mb-1">{jewellery?.title}</h5>
              <div className="flex items-center gap-3 mb-4">
                <h4 className="text-2xl font-semibold">
                  {typeof totalJewelleryPrice?.priceWithDiscount === "number"
                    ? `$${totalJewelleryPrice?.priceWithDiscount.toFixed(2)}`
                    : "$0.00"}
                </h4>
                {jewellery?.isDiscounted && totalJewelleryPrice?.discountPrice > 0 && (
                  <span className="text-lg text-slate-500 line-through dark:text-zink-200">
                    ${totalJewelleryPrice?.priceWithoutDiscount.toFixed(2)}
                  </span>
                )}
              </div>
              
              {/* Price Breakdown */}
              <div className="p-4 mb-4 border rounded-md border-slate-200 dark:border-zink-500 bg-slate-50 dark:bg-zink-700">
                <h6 className="mb-3 text-sm font-semibold text-slate-700 dark:text-zink-100">
                  Price Breakdown
                </h6>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-slate-600 dark:text-zink-200">
                      Metal Price ({metal} {karat}) - {jewellery?.metal?.[karat]?.toFixed(3) || "0.000"}g:
                    </span>
                    <span className="font-medium text-slate-800 dark:text-zink-50">
                      ${separatePrices?.metalPrice?.toFixed(2) || "0.00"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600 dark:text-zink-200">
                      Center Stone ({jewellery?.shape}) - 1.00ct:
                    </span>
                    <span className="font-medium text-slate-800 dark:text-zink-50">
                      ${separatePrices?.centerStonePrice?.toFixed(2) || "0.00"}
                    </span>
                  </div>
                  {jewellery?.diamonds && jewellery.diamonds.length > 0 && (
                    <div className="flex justify-between">
                      <span className="text-slate-600 dark:text-zink-200">
                        Side Stones - {jewellery?.diamonds?.reduce((sum: number, d: any) => sum + (d.carat * d.pieces), 0).toFixed(2)}ct:
                      </span>
                      <span className="font-medium text-slate-800 dark:text-zink-50">
                        ${separatePrices?.sideStonesPrice?.toFixed(2) || "0.00"}
                      </span>
                    </div>
                  )}
                  <div className="pt-2 border-t border-slate-200 dark:border-zink-500">
                    <div className="flex justify-between">
                      <span className="text-slate-600 dark:text-zink-200">Subtotal:</span>
                      <span className="font-medium text-slate-800 dark:text-zink-50">
                        ${totalJewelleryPrice?.subTotal?.toFixed(2) || "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600 dark:text-zink-200">
                      Margin ({process.env.REACT_APP_JEWELLERY_MARGIN_PRICE}%):
                    </span>
                    <span className="font-medium text-slate-800 dark:text-zink-50">
                      ${((totalJewelleryPrice?.subTotal * Number(process.env.REACT_APP_JEWELLERY_MARGIN_PRICE)) / 100)?.toFixed(2) || "0.00"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600 dark:text-zink-200">
                      Tax ({process.env.REACT_APP_JEWELLERY_TAX_PRICE}%):
                    </span>
                    <span className="font-medium text-slate-800 dark:text-zink-50">
                      ${totalJewelleryPrice?.taxAmount?.toFixed(2) || "0.00"}
                    </span>
                  </div>
                  {jewellery?.isDiscounted && totalJewelleryPrice?.discountPrice > 0 && (
                    <div className="flex justify-between text-green-600 dark:text-green-400">
                      <span>Discount:</span>
                      <span className="font-medium">
                        -${totalJewelleryPrice?.discountPrice?.toFixed(2) || "0.00"}
                      </span>
                    </div>
                  )}
                  <div className="pt-2 border-t border-slate-300 dark:border-zink-400">
                    <div className="flex justify-between text-base font-semibold">
                      <span className="text-slate-800 dark:text-zink-50">Total Price:</span>
                      <span className="text-custom-500">
                        ${totalJewelleryPrice?.priceWithDiscount?.toFixed(2) || "0.00"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <h6 className="mt-5 mb-3 text-15">Select Metal</h6>
              <div className="flex flex-wrap items-center gap-2">
                <div>
                  <input
                    id="select-metal-yellowgold-14k"
                    className="hidden peer"
                    type="radio"
                    value="yellowgold"
                    name="selectMetal"
                    // defaultChecked
                    onChange={() => handleSelectionChange("yellowgold", "14k")}
                    // onChange={(e) => {
                    //   e.target.checked && setMetal("gold");
                    // }}
                  />
                  <label
                    htmlFor="select-metal-yellowgold-14k"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 bg-yellow-600 dark:peer-checked:bg-yellow-600/20 peer-checked:border-yellow-300 dark:peer-checked:border-yellow-700 text-white peer-disabled:opacity-50 dark:peer-disabled:bg-slate-500/20 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    14K
                  </label>
                </div>
                <div>
                  <input
                    id="select-metal-rosegold-14k"
                    className="hidden peer "
                    type="radio"
                    value="rosegold"
                    name="selectMetal"
                    onChange={() => handleSelectionChange("rosegold", "14k")}
                    // onChange={(e) => {
                    //   e.target.checked && setMetal("rosegold");
                    // }}
                  />
                  <label
                    htmlFor="select-metal-rosegold-14k"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 bg-rosegold text-white  dark:peer-checked:bg-custom-500/20 peer-checked:border-custom-300 dark:peer-checked:border-custom-700 peer-disabled:bg-slate-50 dark:peer-disabled:bg-slate-500/20 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    14K
                  </label>
                </div>
                <div>
                  <input
                    id="select-metal-whitegold-14k"
                    className="hidden peer "
                    type="radio"
                    value="whitegold"
                    name="selectMetal"
                    onChange={() => handleSelectionChange("whitegold", "14k")}
                    // onChange={(e) => {
                    //   e.target.checked && setMetal("whitegold");
                    // }}
                  />
                  <label
                    htmlFor="select-metal-whitegold-14k"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 bg-slate-300 dark:peer-checked:bg-slate-300/20 peer-checked:border-slat-300 dark:peer-checked:border-slat-700 peer-disabled:bg-slate-50 text-white dark:peer-disabled:bg-slate-500/20 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200 "
                  >
                    14K
                  </label>
                </div>
                <div>
                  <input
                    id="select-metal-yellowgold-18k"
                    className="hidden peer"
                    type="radio"
                    value="yellowgold"
                    name="selectMetal"
                    defaultChecked
                    onChange={() => handleSelectionChange("yellowgold", "18k")}
                    // onChange={(e) => {
                    //   e.target.checked && setMetal("gold");
                    // }}
                  />
                  <label
                    htmlFor="select-metal-yellowgold-18k"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 bg-yellow-600 dark:peer-checked:bg-yellow-600/20 peer-checked:border-yellow-300 dark:peer-checked:border-yellow-700 text-white peer-disabled:opacity-50 dark:peer-disabled:bg-slate-500/20 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    18K
                  </label>
                </div>
                <div>
                  <input
                    id="select-metal-rosegold-18k"
                    className="hidden peer "
                    type="radio"
                    value="rosegold"
                    name="selectMetal"
                    onChange={() => handleSelectionChange("rosegold", "18k")}
                    // onChange={(e) => {
                    //   e.target.checked && setMetal("rosegold");
                    // }}
                  />
                  <label
                    htmlFor="select-metal-rosegold-18k"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 bg-rosegold text-white  dark:peer-checked:bg-custom-500/20 peer-checked:border-custom-300 dark:peer-checked:border-custom-700 peer-disabled:bg-slate-50 dark:peer-disabled:bg-slate-500/20 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    18K
                  </label>
                </div>
                <div>
                  <input
                    id="select-metal-whitegold-18k"
                    className="hidden peer "
                    type="radio"
                    value="whitegold"
                    name="selectMetal"
                    onChange={() => handleSelectionChange("whitegold", "18k")}
                    // onChange={(e) => {
                    //   e.target.checked && setMetal("whitegold");
                    // }}
                  />
                  <label
                    htmlFor="select-metal-whitegold-18k"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 bg-slate-300 dark:peer-checked:bg-slate-300/20 peer-checked:border-slat-300 dark:peer-checked:border-slat-700 peer-disabled:bg-slate-50 text-white dark:peer-disabled:bg-slate-500/20 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200 "
                  >
                    18K
                  </label>
                </div>
              </div>
           
              
              <div className="mt-5">
                <h6 className="mb-3 text-15">Product Description:</h6>
                {jewellery?.description}
              </div>
              <div className="mt-5">
                <h6 className="mb-3 text-15">Specs:</h6>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <tbody>
                      <tr>
                        <th className="px-3.5 py-2.5 font-semibold border-b border-transparent w-64 ltr:text-left rtl:text-right text-slate-500 dark:text-zink-200 ">
                          Category
                        </th>
                        <td className="px-3.5 py-2.5 border-b border-transparent capitalize">
                          {jewellery?.category}
                        </td>
                      </tr>
                      <tr>
                        <th className="px-3.5 py-2.5 font-semibold border-b border-transparent w-64 ltr:text-left rtl:text-right text-slate-500 dark:text-zink-200">
                          Sub Category
                        </th>
                        <td className="px-3.5 py-2.5 border-b border-transparent capitalize">
                          {jewellery?.subcategory}
                        </td>
                      </tr>

                      <tr>
                        <th className="px-3.5 py-2.5 font-semibold border-b border-transparent w-64 ltr:text-left rtl:text-right text-slate-500 dark:text-zink-200">
                          Sku
                        </th>
                        <td className="px-3.5 py-2.5 border-b border-transparent">
                          {jewellery?.sku}
                        </td>
                      </tr>
                      <tr>
                        <th className="px-3.5 py-2.5 font-semibold border-b border-transparent w-64 ltr:text-left rtl:text-right text-slate-500 dark:text-zink-200">
                          Product Code
                        </th>
                        <td className="px-3.5 py-2.5 border-b border-transparent">
                          {jewellery?._id}
                        </td>
                      </tr>
                      <tr>
                        <th className="px-3.5 py-2.5 font-semibold border-b border-transparent w-64 ltr:text-left rtl:text-right text-slate-500 dark:text-zink-200">
                          Ideal for
                        </th>
                        <td className="px-3.5 py-2.5 border-b border-transparent capitalize">
                          {jewellery?.gender}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Overview Modal */}
      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen lg:xl:w-[55rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-5 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">
            {!!isEdit ? "Edit Review" : "Add Review"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
              <div className="xl:col-span-4">
                <label
                  htmlFor="createDateInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Create Date
                </label>
                <Flatpickr
                  id="createDateInput"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  options={{
                    dateFormat: "d M, Y",
                  }}
                  placeholder="Select date"
                  name="date"
                  onChange={(date: any) =>
                    validation.setFieldValue(
                      "date",
                      moment(date[0]).format("DD MMMM ,YYYY")
                    )
                  }
                  value={validation.values.date || ""}
                />
                {validation.touched.date && validation.errors.date ? (
                  <p className="text-red-400">{validation.errors.date}</p>
                ) : null}
              </div>
              <div className="xl:col-span-4">
                <label
                  htmlFor="notesTitleInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Give your review a title
                </label>
                <input
                  type="text"
                  id="notesTitleInput"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Title"
                  name="customerName"
                  onChange={validation.handleChange}
                  value={validation.values.customerName || ""}
                />
                {validation.touched.customerName &&
                validation.errors.customerName ? (
                  <p className="text-red-400">
                    {validation.errors.customerName}
                  </p>
                ) : null}
              </div>
              <div className="xl:col-span-4">
                <div>
                  <label
                    htmlFor="categorySelect"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Rating
                  </label>
                  <select
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    data-choices
                    data-choices-search-false
                    id="statusSelect"
                    name="rating"
                    onChange={validation.handleChange}
                    value={validation.values.rating || ""}
                  >
                    <option value="">Select Rating</option>
                    <option value="5">5 Star</option>
                    <option value="4">4 Star</option>
                    <option value="3">3 Star</option>
                    <option value="2">2 Star</option>
                    <option value="1">1 Star</option>
                  </select>
                  {validation.touched.rating && validation.errors.rating ? (
                    <p className="text-red-400">{validation.errors.rating}</p>
                  ) : null}
                </div>
              </div>
              <div className="xl:col-span-12">
                <div>
                  <label
                    htmlFor="textArea"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Your review
                  </label>
                  <textarea
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    id="textArea"
                    placeholder="Enter Description"
                    rows={6}
                    name="review"
                    onChange={validation.handleChange}
                    value={validation.values.review || ""}
                  ></textarea>
                  {validation.touched.review && validation.errors.review ? (
                    <p className="text-red-400">{validation.errors.review}</p>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-2 mt-4">
              <button
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {!!isEdit ? "Update" : "Add Review"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default JewelleryOverview;
